import { useState, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';

import { useNavigate } from 'react-router-dom';
import { classNames } from '../../../../shared/utility';

import { deleteVideo, refreshFetchFunctions } from '../../../../apiFunctions/apiFunctions';
import Icon from '../../../../components/UI/Icon/Icon';
import { NotificationContext } from '../../../../context/Notification/NotificationContext';
import ModalButtonsContainer from '../../../../components/UI/ModalButtonsContainer/ModalButtonsContainer';
import Button from '../../../../components/UI/Button/Button';
import { Modal, Progress } from 'antd';

import AddEditVideo from '../../VideosList/AddEditVideo/AddEditVideo';

const Thumbnail = ({
  video = {},
  isAdmin = false,
  categories = { active: [] },
  productList = [],
  gymId = '',
  isSelector = false,
  onSelect = () => {},
  isDefaultSelected = false,
  locked = false,
  className = '',
  isFromClientProfile,
  percentageWatched,
  showProgress
}) => {
  const { openNotification } = useContext(NotificationContext);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isSelected, setIsSelected] = useState(isDefaultSelected);
  const navigate = useNavigate();
  const thumbnailMedia = video.media?.find((media) => media.type === 'Thumbnail');
  const thumbnailUrl = thumbnailMedia?.files?.[0]?.path ?? '';

  const { mutate: onDeleteVideo, isLoading: onDeleteVideoIsLoading } = useMutation(
    () =>
      deleteVideo(
        video._id,
        productList.filter((elm) => elm.videos.includes(video._id))
      ),
    {
      onSuccess: () => {
        refreshFetchFunctions([['fetchVideos'], ['fetchPasses', 'videoPasses']]);
        openNotification('delete', 'success');
      },
      onError: () => {
        openNotification('default', 'error');
      }
    }
  );
  const onCloseModal = () => setShowModal(false);
  const returnModalContent = () => {
    if (isEdit) {
      return (
        <AddEditVideo selected={video} productsList={productList} categories={categories} onCancel={onCloseModal} />
      );
    }
    return (
      <>
        <div className="text-center">Are you sure you want to delete video: {video.title} ?</div>
        <ModalButtonsContainer isLoading={onDeleteVideoIsLoading}>
          <Button label="delete" secondary onClick={onDeleteVideo} />
          <Button label="cancel" primary onClick={onCloseModal} />
        </ModalButtonsContainer>
      </>
    );
  };
  const handleSelection = (id) => {
    setIsSelected((state) => !state);
    onSelect(id);
  };

  return (
    <>
      <Modal open={showModal} onCancel={onCloseModal}>
        {returnModalContent()}
      </Modal>
      <div
        className={classNames(
          'w-full min-w-[150px] pb-3  m-2 relative',
          !isSelector && 'hover:brightness-50 hover:text-custom-accent',
          className,
          isFromClientProfile ? 'max-w-[200px]' : 'max-w-[300px]'
        )}>
        <img
          src={thumbnailUrl}
          alt={video.title}
          className={classNames(
            !isFromClientProfile && 'rounded-t-lg',
            'object-cover',
            locked ? 'cursor-not-allowed blur-sm' : 'cursor-pointer',
            isSelected && 'brightness-50'
          )}
          onClick={() =>
            locked
              ? null
              : isSelector
                ? handleSelection(video._id)
                : navigate(isAdmin ? `/gym/${gymId}/videos/${video._id}` : `/gym/videos/${video._id}`)
          }
        />
        <Icon
          name={'lock'}
          cursorPointer={false}
          className={'absolute top-[calc(50%-40px)] left-[calc(50%-30px)]'}
          show={locked}
          size={40}
        />

        <div
          className={classNames(
            isAdmin ? 'grid grid-cols-[1fr_80px] gap-x-2' : '',
            isSelected && 'rounded-b-lg bg-custom-ok-border brightness-50'
          )}>
          <div className={'ml-2 my-2 font-bold items-center'}>{video.title}</div>
          {showProgress && (
            <div className={'flex my-2'}>
              <Progress percent={percentageWatched} />
            </div>
          )}
          {isAdmin && !isSelector && !isFromClientProfile && (
            <div className={'flex my-2'}>
              <Icon
                name={'edit'}
                onClick={() => {
                  setIsEdit(true);
                  setShowModal(true);
                }}
              />
              <Icon
                name={'trash'}
                onClick={() => {
                  setIsEdit(false);
                  setShowModal(true);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Thumbnail;
